import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-common-announcement',
  templateUrl: './common-announcement.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class CommonAnnouncementComponent implements OnInit {
  @Input() announcementMessage: string = ''; // To pass the message to the component
  
  ngOnInit(): void {
    // Optional: Logic to handle message if needed.
  }
}
